import CustomViewDialogStore from "csi/middleware/customView/CustomViewDialogStore";
import DataSheetCustomViewOptionsStore from "csi/middleware/customView/options/DataSheetCustomViewOptionsStore";
import { action, makeObservable } from "mobx";
import { FunctionComponent, SyntheticEvent } from "react";
import { ICustomViewDataSheetSizeChartOptions } from "src/ProductSpec/SizeChart/CustomViewSizeChartOptions";
import { ICustomViewDataSheetSizeChartDropDownOptions } from "./CustomViewSizeChartOptions";

/**
 * This store contains information about Size chart options
 */
class SizeChartDataSheetCustomViewOptionsStore extends DataSheetCustomViewOptionsStore<ICustomViewDataSheetSizeChartOptions> {
	constructor(
		sizeChartDropDownOptions: ICustomViewDataSheetSizeChartDropDownOptions,
		component: FunctionComponent,
		customViewDialogStore: CustomViewDialogStore,
		options?: ICustomViewDataSheetSizeChartOptions,
	) {
		super(sizeChartDropDownOptions, component, customViewDialogStore, options);
		makeObservable(this);
	}

	@action setSizeChartPrintSubSizeRanges = (event: SyntheticEvent, value: boolean): void => {
		this.options.sizeChartPrintSubSizeRanges = value;
	};
}

export = SizeChartDataSheetCustomViewOptionsStore;